import { ProductionGroupBase } from './base/production-group-base';

export class ProductionGroup extends ProductionGroupBase { }